import { JSX, HTMLAttributes } from "react";
import cn from "classnames";
import { IAvailableReviewPeriod } from "@/service/review-period";

interface PeriodSelectorProps extends HTMLAttributes<HTMLDivElement> {
  periods: IAvailableReviewPeriod[];
  selectedPeriod?: IAvailableReviewPeriod;
  onSelectPeriod: (period: IAvailableReviewPeriod) => void;
}

export const PeriodSelector = (props: PeriodSelectorProps): JSX.Element => {
  const { periods, selectedPeriod, onSelectPeriod, className, ...otherProps } = props;

  return (
    <div className={cn("flex gap-2", className)} {...otherProps}>
      {periods.map((period) => (
        <button
          key={period.label}
          type="button"
          onClick={() => onSelectPeriod(period)}
          aria-label={`Select period ${period.label}`}
          aria-pressed={selectedPeriod?.label === period.label}
          className={cn(
            "cursor-pointer rounded-lg p-3 text-sm font-bold transition-colors",
            selectedPeriod?.label === period.label
              ? "bg-slate-700 text-slate-100"
              : "text-eerie-black bg-gray-200 hover:bg-gray-300",
          )}
        >
          {period.label}
        </button>
      ))}
    </div>
  );
};
